const MESSAGES_TYPES = {
  ADD: '[messages] add',
  HIDE: '[messages] hide',
  GC: '[messages] garbageCollection'
}

export default MESSAGES_TYPES
